import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { IndexPath } from '@/Config/app/router/index.path';
import { useCurrentIndexPath } from '@/Config/app/router/useIndexPath.hook';
import { SidebarMenuButton } from '@/Domain/components/Shared/Sidebar/Sidebar';
import { BotIcon, BotIconHandle } from '@/Domain/components/icons/BotIcon';

export const SidebarPreviewButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation('sidebar_menu');
  const currentPath = useCurrentIndexPath();
  const iconRef = useRef<BotIconHandle>(null);

  return (
    <SidebarMenuButton
      asChild
      tooltip={t('menu.ai_preview')}
      isActive={currentPath == IndexPath.aiPreview}
      className={className}
      onMouseEnter={() => iconRef.current?.startAnimation()}
      onMouseLeave={() => iconRef.current?.stopAnimation()}
    >
      <NavLink to={IndexPath.aiPreview} data-shortcut="1" viewTransition>
        <BotIcon ref={iconRef} size={16} />
        <span>{t('menu.ai_preview')}</span>
      </NavLink>
    </SidebarMenuButton>
  );
};
